import image01 from "@/public/mock_images/image_01.webp";
import image02 from "@/public/mock_images/image_02.webp";
import image03 from "@/public/mock_images/image_03.webp";
import image04 from "@/public/mock_images/image_04.webp";
import image05 from "@/public/mock_images/image_05.webp";
import image06 from "@/public/mock_images/image_06.webp";
import image07 from "@/public/mock_images/image_07.webp";
import image08 from "@/public/mock_images/image_08.webp";

// Icons
import icon01 from "@/public/services/Icon1.svg";
import icon02 from "@/public/services/Icon2.svg";
import icon03 from "@/public/services/Icon3.svg";
import icon04 from "@/public/services/Icon4.svg";
import icon05 from "@/public/services/Icon5.svg";
import icon06 from "@/public/services/Icon6.svg";
import { StaticImageData } from "next/image";

export type Service = {
  icon: StaticImageData;
  title: string;
  subtitle: string;
  card_1?:
    | {
        title: string | undefined;
        subtitle: string | undefined;
        description: string | undefined;
        image: StaticImageData | undefined;
      }
    | undefined;
  card_2?:
    | {
        title: string | undefined;
        subtitle: string | undefined;
        description: string | undefined;
        image: StaticImageData | undefined;
      }
    | undefined;
  before_after?:
    | {
        title: string | undefined;
        description: string | undefined;
        beforeImage: StaticImageData | undefined;
        afterImage: StaticImageData | undefined;
      }
    | undefined;
};

export const services: Record<string, Service> = {
  default: {
    icon: icon01,
    title: "Usluge",
    subtitle:
      "Bilo da se radi o rutinskom pregledu ili složenom zahvatu, vaše oralno zdravlje nam je prioritet kako biste mogli postići samopouzdan osmijeh.",
  },
  "preventive-care": {
    icon: icon01,
    title: "Preventivna dentalna skrb",
    subtitle:
      "Vaše oralno zdravlje počinje preventivnom skrbi. Redoviti pregledi, profesionalno čišćenje i pravovremene intervencije ključ su dugotrajnog i zdravog osmijeha.",
    card_1: {
      title: "Održavanje oralnog zdravlja",
      subtitle:
        "Preventiva je najbolja medicina – redoviti stomatološki pregledi omogućavaju rano otkrivanje problema i njihovo jednostavno rješavanje.",
      description:
        "Preventivna dentalna skrb temelj je zdravih zubi i desni. Naš tim provodi detaljne preglede, uključujući pregled zuba, desni i mekih tkiva usne šupljine. Profesionalno čišćenje uklanja zubne naslage i kamenac koje redovito pranje ne može doseći. Fluoridacija jača caklinu i štiti od karijesa. Savjetujemo vas o pravilnoj tehnici četkanja, upotrebi zubnog konca i odabiru odgovarajućih proizvoda za oralnu higijenu. Preventivnim pristupom izbjegavate složene i skupe zahvate u budućnosti.",
      image: image06,
    },
    card_2: {
      title: "Redoviti pregledi i zaštita",
      subtitle:
        "Profesionalno čišćenje, fluoridacija i individualizirane upute za održavanje oralnog zdravlja za cijelu obitelj.",
      description:
        "Redoviti dentalni pregledi su osnova preventivne stomatologije i omogućavaju rano otkrivanje problema dok su još mali i jednostavni za liječenje. Preporučamo kontrolne preglede svakih 6 mjeseci za odrasle i svakih 3-4 mjeseca za djecu. Tijekom pregleda ocjenjujemo stanje zubi, desni, jezika, nepca i cijele usne šupljine. Profesionalno čišćenje uključuje ultrazvučno uklanjanje zubnog kamenca, poliranje zubi posebnim pastama i četkicama te aplikaciju fluoridnih preparata za jačanje cakline. Posebnu pažnju posvećujemo edukaciji – pokazujemo ispravnu tehniku četkanja, pravilnu upotrebu zubnog konca i međuzubnih četkica. Za djecu provodimo preventivne mjere poput fisurnih pečata koji štite zadnje kutnjake od karijesa.",
      image: image07,
    },
    before_after: {
      title: "Transformacija zdravog osmijeha",
      description: "Čišći i zdraviji zubi",
      beforeImage: image06,
      afterImage: image07,
    },
  },
  "periodontal-therapy": {
    icon: icon02,
    title: "Parodontalna terapija",
    subtitle:
      "Specijalizirani pristup liječenju parodontalnih oboljenja – od najranijih stadija do naprednih intervencija. Vraćamo zdravlje i funkcionalnost potpornom aparatu zuba.",
    card_1: {
      title: "Sveobuhvatno liječenje parodonta",
      subtitle:
        "Stručno liječenje upala i degenerativnih procesa desni, parodontalnih ligamenata i alveolarne kosti pomoću suvremenih terapijskih protokola.",
      description:
        "Parodontalna terapija obuhvaća dijagnostiku i liječenje svih oboljenja potpornog aparata zuba. Parodontalna bolest je kronična infekcija koja uništava tkiva koja podupiru zube – desni, parodontalni ligament i alveolarnu kost. Naša terapija počinje detaljnom dijagnostikom koja uključuje mjerenje parodontalnih džepova, rendgensku analizu koštanog gubitka i procjenu opće oralne situacije. Primjenjujemo neinvazivne metode poput skaliranja i poliranja korijena, antimikrobne terapije, te kirurške intervencije kada je potrebno. Cilj je eliminirati upalu, zaustaviti progresiju bolesti i regenerirati izgubljeno tkivo.",
      image: image01,
    },
    card_2: {
      title: "Zaštita i regeneracija",
      subtitle:
        "Napredne tehnike za suzbijanje infekcije, smanjenje upale i poticanje regeneracije parodontalnih tkiva za dugoročno zdravlje.",
      description:
        "Uspješno liječenje parodontalnih oboljenja zahtijeva sveobuhvatan pristup koji kombinira mehaničko uklanjanje uzročnika bolesti i biološku modulaciju zapalnog odgovora. Nakon inicijalne terapije, fokus prelazi na održavanje postignutih rezultata i regeneraciju oštećenih tkiva. Primjenjujemo lokalne antimikrobne agense, probiotike za oralnu šupljinu i suportivnu terapiju koja uključuje redovite kontrole i profesionalno održavanje. Za napredne slučajeve koristimo regenerativne tehnike s faktorima rasta i bioaktivnim materijalima koji potiču regeneraciju parodontalnog ligamenta, cementa i alveolarne kosti. Program parodontalnog održavanja prilagođavamo svakom pacijentu ovisno o težini bolesti, rizičnim faktorima i individualnom odgovoru na terapiju.",
      image: image02,
    },
    before_after: {
      title: "Oporavak parodontalnog zdravlja",
      description: "Zdravlje vraćeno desnima",
      beforeImage: image01,
      afterImage: image02,
    },
  },
  "gum-disease-treatment": {
    icon: icon03,
    title: "Liječenje bolesti desni",
    subtitle:
      "Ciljano liječenje gingivitisa i parodontitisa – od početnih simptoma do naprednih stadija. Sprječavamo napredovanje bolesti i čuvamo vaše prirodne zube.",
    card_1: {
      title: "Od gingivitisa do parodontitisa",
      subtitle:
        "Rana intervencija kod upale desni sprječava razvoj ozbiljnijih komplikacija i trajnog oštećenja potpornih struktura zuba.",
      description:
        "Bolesti desni kreću od blagog gingivitisa – upale desni koju karakterizira crvenilo, oteklina i krvarenje pri pranju zuba. Ako se ne liječi, može progredirati u parodontitis, ozbiljnu infekciju koja oštećuje meka tkiva i kost koja podupire zube, što može dovesti do gubitka zuba. Naš tretman uključuje profesionalno uklanjanje supragingivnog i subgingivnog zubnog kamenca, dezinfekciju parodontalnih džepova, primjenu lokalnih antiseptika i antibiotika kada je potrebno. Educiramo pacijente o pravilnoj oralnoj higijeni i redovitim kontrolama. Rana dijagnoza i tretman ključni su za uspješno liječenje i prevenciju daljnjih komplikacija.",
      image: image03,
    },
    card_2: {
      title: "Profesionalni pristup zdravlju desni",
      subtitle:
        "Kombinirani pristup mehaničkog čišćenja, antimikrobne terapije i edukacije pacijenata za optimalne rezultate liječenja.",
      description:
        "Liječenje gingivitisa i parodontitisa je proces koji zahtijeva aktivnu suradnju između stomatologa i pacijenta. Naš protokol počinje temeljitom dijagnostikom – određivanjem stadija bolesti pomoću parodontalnog indeksa, radiografskih snimaka i mikrobiološke analize kada je indicirana. Terapija se odvija u fazama: prva faza uključuje edukaciju o bolesti, motivaciju za poboljšanje oralne higijene i profesionalno čišćenje. Druga faza može uključiti primjenu antiseptičkih ili antibiotičkih preparata, lokalnu irigaciju parodontalnih džepova i kontrolu sistemskih faktora rizika poput pušenja ili dijabetesa. Redovito praćenje omogućava procjenu uspjeha terapije i pravovremenu intervenciju ako dođe do pogoršanja. Naš cilj je transformirati akutnu upalu u kronično stabilno stanje koje se može dugoročno kontrolirati.",
      image: image04,
    },
    before_after: {
      title: "Od upale do zdravlja",
      description: "Prestanak upale desni",
      beforeImage: image03,
      afterImage: image04,
    },
  },
  "deep-cleaning": {
    icon: icon04,
    title: "Dubinsko parodontalno čišćenje",
    subtitle:
      "Scaling i root planing – napredna procedura za dubinsko čišćenje korijena zuba i subgingivalno uklanjanje bakterijskih naslaga i kamenca.",
    card_1: {
      title: "Scaling & Root Planing",
      subtitle:
        "Neinvazivna terapijska procedura za duboko čišćenje i glačanje površine korijena zuba, omogućava ponovno pričvršćivanje desni.",
      description:
        "Dubinsko parodontalno čišćenje je specijalizirani tretman koji nadilazi standardno čišćenje zubi. Procedura obuhvaća scaling – profesionalno uklanjanje zubnog kamenca i bakterijskog plaka sa svih površina zuba, uključujući područja ispod linije desni gdje se formiraju parodontalni džepovi. Root planing je glačanje površine korijena zuba kako bi se uklonile bakterije, toksini i biofilm, te stvorila glatka površina kojoj se desni mogu ponovno pričvrstiti. Ova terapija se izvodi pod lokalnom anestezijom za maksimalnu udobnost pacijenta. Nakon tretmana, desni se zacjeljuju, upala se smanjuje, a džepovi postaju plići, što omogućava bolju oralnu higijenu i zaustavlja napredovanje parodontalne bolesti.",
      image: image05,
    },
    card_2: {
      title: "Terapijsko dubinsko čišćenje",
      subtitle:
        "Precizno uklanjanje subgingivalnih naslaga uz lokalno primijenjenu anesteziju za ugodnu i efikasnu terapiju.",
      description:
        "Dubinsko parodontalno čišćenje je terapijska procedura koja se izvodi u slučajevima umjerenog do naprednog parodontitisa kada standardno čišćenje nije dovoljno. Tretman obično zahtijeva više posjeta, pri čemu se svaki kvadrant usne šupljine tretira zasebno kako bi se postigla maksimalna preciznost. Korištenjem ultrazvučnih instrumenata i ručnih kireti, stomatolog pristupa duboko ispod ruba desni, uklanjajući čvrste naslage kamenca i biofilm bakterija s površine korijena. Root planing zatim stvara glatku površinu koja je neprijateljska za bakterijsku kolonizaciju i pogodna za ponovno pričvršćivanje desnog tkiva. Nakon procedure, pacijenti mogu osjetiti osjetljivost koja se ublažava u roku od nekoliko dana. Rezultati uključuju smanjenje dubine parodontalnih džepova, prestanak krvarenja desni i poboljšanje općeg parodontalnog zdravlja.",
      image: image08,
    },
    before_after: {
      title: "Dubinsko čišćenje i oporavak",
      description: "Plići i zdraviji džepovi",
      beforeImage: image05,
      afterImage: image08,
    },
  },
  "gum-grafting": {
    icon: icon05,
    title: "Presađivanje gingivalnog tkiva",
    subtitle:
      "Mukogingivalna kirurgija za korekciju recesije desni – estetska i funkcionalna rekonstrukcija gingivnog tkiva uz autologne ili aloplastične transplantate.",
    card_1: {
      title: "Kirurška korekcija recesije desni",
      subtitle:
        "Mikrokirurške tehnike za prekrivanje izloženih korijena zuba i povećanje širine pričvrsne gingive – rješavamo osjetljivost i estetske probleme.",
      description:
        "Recesija desni nastaje kada se gingivno tkivo povlači od zuba, ostavljajući korijene izloženim. To može uzrokovati osjetljivost, estetske probleme i povećan rizik od karijesa korijena. Presađivanje desni je parodontalna kirurška procedura koja obnavlja izgubljeno tkivo. Najčešće koristimo tehniku slobodnog gingivalnog grafta ili vezivnotkivnog grafta (connective tissue graft), gdje se tkivo uzima s nepca ili iz druge oblasti i postavlja na mjesto recesije. Moderne tehnike uključuju i alogene materijale koji eliminiraju potrebu za uzimanjem tkiva s donorskog mjesta. Procedura se izvodi uz lokalnu anesteziju, a rezultati uključuju smanjenu osjetljivost, poboljšanu estetiku osmjeha, zaštitu korijena od karijesa i sprječavanje daljnje recesije.",
      image: image01,
    },
    card_2: {
      title: "Rekonstrukcija i zaštita",
      subtitle:
        "Napredne parodontalne plastično-kirurške tehnike za obnovu funkcije i estetike gingivalnog tkiva uz predvidljive rezultate.",
      description:
        "Mukogingivalna kirurgija predstavlja specijalizirano područje parodontalne kirurgije koje se bavi estetskim i funkcionalnim problemima vezanim za desni. Osim presađivanja desni za prekrivanje recesija, ova grana uključuje i koronalno repozicioniranje režnja, lateralno repozicionirani režanj te tekniku tuneliranja. Svaka tehnika se bira ovisno o veličini i lokaciji recesije, debljini postojećeg tkiva i estetskim zahtjevima pacijenta. Postoperativna njega je ključna za uspjeh – pacijenti dobivaju detaljne upute o prehrani, oralnoj higijeni i izbjegavanju mehaničke traume. Zacjeljivanje traje nekoliko tjedana, a potpuni estetski rezultati vidljivi su nakon 3-6 mjeseci. Stopa uspješnosti ovih procedura je vrlo visoka kada se izvode od strane iskusnih parodontologa, s dugotrajnim i stabilnim rezultatima.",
      image: image02,
    },
    before_after: {
      title: "Prekrivanje recesije i estetska obnova",
      description: "Prekriveni korijeni zuba",
      beforeImage: image01,
      afterImage: image02,
    },
  },
  "bone-regeneration": {
    icon: icon06,
    title: "Augmentacija i regeneracija alveolarne kosti",
    subtitle:
      "Napredne tehnike vođene tkivne i koštane regeneracije (GTR/GBR) pomoću membrana i koštanih nadomjestaka za obnovu izgubljene alveolarne kosti.",
    card_1: {
      title: "Vođena tkivna regeneracija",
      subtitle:
        "Znanstveno dokazane regenerativne procedure uz primjenu biokompatibilnih membrana, autolognih ili ksenogenih koštanih grafova za obnovu potpornih struktura.",
      description:
        "Parodontalna bolest često dovodi do gubitka alveolarne kosti koja podupire zube, što može ugroziti stabilnost zubi ili onemogućiti postavljanje dentalnih implantata. Regeneracija kosti koristi napredne tehnike vođene tkivne regeneracije (GTR – Guided Tissue Regeneration) i vođene koštane regeneracije (GBR – Guided Bone Regeneration). Primjenjujemo resorptivne ili neresorptivne barijerne membrane koje sprječavaju ulazak epitelnih stanica i omogućavaju koštanim stanicama da regeneriraju izgubljeno tkivo. Koristimo različite koštane nadomjeske: autologne (iz vlastitog tijela), alogene (ljudski donorski materijal), ksenogene (životinjskog porijekla) ili sintetske biomaterijale. Često kombiniramo ove materijale s faktorima rasta i biološkim molekulama za optimalne rezultate. Ova procedura omogućava postavljanje implantata, poboljšava stabilnost zuba i vraća zdravu anatomiju parodontalnih struktura.",
      image: image03,
    },
    card_2: {
      title: "Koštani nadomjesci i biomatrijali",
      subtitle:
        "Primjena suvremenih biomaterijala i regenerativnih tehnika za predvidljivu i dugotrajnu obnovu koštanog volumena.",
      description:
        "Izbor odgovarajućeg koštanog nadomjeska ključan je za uspjeh regenerativne terapije. Autologni koštani graft, uzet iz vlastitog tijela (često iz brade ili ramusa mandibule), smatra se zlatnim standardom zbog svoje osteogene, osteoinduktivne i osteokonduktivne prirode. Međutim, zahtijeva dodatno kirurško mjesto i produžava postupak. Alogeni grafti (ljudskog porijekla) i ksenogeni grafti (najčešće bovinski) nude izvrsnu alternativu s dobrom biokompatibilnošću i predvidljivim rezultatima. Sintetski materijali poput hidroksiapatita i beta-trikalcij fosfata postaju sve popularniji zbog neograničene dostupnosti i eliminacije rizika prijenosa bolesti. Moderne tehnike uključuju kombinaciju različitih materijala, primjenu plazme bogate trombocitima (PRP) i faktora rasta za ubrzano zacjeljivanje. Procedure koštane augmentacije otvaraju mogućnosti za uspješnu implantološku rehabilitaciju i poboljšavaju dugoročnu prognozu preostalih zuba.",
      image: image04,
    },
    before_after: {
      title: "Regeneracija izgubljenog volumena",
      description: "Obnovljena koštana struktura",
      beforeImage: image03,
      afterImage: image04,
    },
  },
  "parodontologija-i-regenerativna-kirurgija": {
    icon: icon02,
    title: "Parodontologija i regenerativna kirurgija",
    subtitle:
      "Terapija uznapredovalih parodontnih bolesti, regeneracija mekih i tvrdih tkiva te dugoročna stabilizacija potpornog aparata zuba.",
    card_1: {
      title: "Dijagnostika i liječenje parodontnih bolesti",
      subtitle:
        "Specijalistički pristup terapiji upala, gubitka kosti i degenerativnih procesa potpornog aparata zuba.",
      description:
        "Parodontologija se bavi dijagnostikom i liječenjem bolesti potpornog aparata zuba — desni, parodontalnog ligamenta i alveolarne kosti. U Dentivo dentalnom centru provodimo detaljnu parodontološku dijagnostiku, mjerenje parodontalnih džepova, rendgensku analizu koštanog gubitka i procjenu opće oralne situacije. Naša terapija obuhvaća neinvazivne metode poput skaliranja i poliranja korijena, antimikrobnu terapiju te kirurške intervencije kada je potrebno. Cilj je eliminirati upalu, zaustaviti progresiju bolesti i stvoriti uvjete za regeneraciju izgubljenog tkiva.",
      image: image01,
    },
    card_2: {
      title: "Regenerativna kirurgija i stabilizacija",
      subtitle:
        "Napredne regenerativne tehnike za obnovu mekih i tvrdih tkiva te dugoročnu stabilnost parodonta.",
      description:
        "Regenerativna parodontalna kirurgija obuhvaća napredne postupke poput vođene tkivne regeneracije (GTR), primjene koštanih nadomjestaka i faktora rasta za obnovu izgubljene kosti i mekog tkiva. Koristimo biokompatibilne membrane, autologne i ksenogene koštane grafove te biološke molekule koje potiču regeneraciju parodontalnog ligamenta, cementa i alveolarne kosti. Svaki slučaj planira se individualno uz strogu kontrolu kvalitete, s ciljem postizanja dugoročne stabilizacije potpornog aparata zuba i očuvanja prirodne denticije.",
      image: image02,
    },
    before_after: {
      title: "Regeneracija parodontalnog tkiva",
      description: "Stabilizacija i obnova potpornog aparata",
      beforeImage: image01,
      afterImage: image02,
    },
  },
  "digitalna-implantologija": {
    icon: icon04,
    title: "Digitalna implantologija",
    subtitle:
      "Precizno planirana implantološka terapija, regeneracija kosti i rješavanje kompleksnih implantoloških situacija.",
    card_1: {
      title: "Precizno planiranje implantološke terapije",
      subtitle:
        "Digitalno vođena implantacija uz 3D dijagnostiku i individualno planiranje za predvidljive rezultate.",
      description:
        "Digitalna implantologija koristi najsuvremenije tehnologije za precizno planiranje i postavljanje dentalnih implantata. CBCT snimke, digitalno skeniranje i softversko planiranje omogućuju virtualno postavljanje implantata prije samog zahvata, čime se postiže maksimalna preciznost i predvidljivost rezultata. U Dentivo dentalnom centru svaki implantološki slučaj planira se individualno, uz analizu koštanog volumena, okluzijskih odnosa i estetskih zahtjeva. S više od 4000 uspješno postavljenih implantata, pružamo sigurnost i iskustvo u rješavanju i najkompleksnijih situacija.",
      image: image03,
    },
    card_2: {
      title: "Regeneracija kosti i kompleksni slučajevi",
      subtitle:
        "Augmentacija koštanog volumena i napredne implantološke tehnike za pacijente s nedostatkom kosti.",
      description:
        "Nedostatak koštanog volumena čest je izazov u implantologiji. Primjenom tehnika vođene koštane regeneracije (GBR), sinus lifta, koštanih blokova i biomaterijala, stvaramo uvjete za uspješnu implantaciju čak i u kompleksnim situacijama. Koristimo isključivo premium implantološke sustave i provjerene biomaterijale. Svaki zahvat izvodi se uz maksimalnu kontrolu detalja — od inicijalne dijagnostike do završnog protetskog rada — s jasno definiranom strategijom dugoročne stabilnosti.",
      image: image04,
    },
    before_after: {
      title: "Implantološka rehabilitacija",
      description: "Potpuna funkcionalnost i estetika",
      beforeImage: image03,
      afterImage: image04,
    },
  },
  "restorativna-endodontska-i-protetska-terapija": {
    icon: icon03,
    title: "Restorativna, endodontska i protetska terapija",
    subtitle:
      "Svi restaurativni i protetski radovi izrađuju se od premium certificiranih materijala uz potpunu kontrolu kvalitete i estetske harmonije.",
    card_1: {
      title: "Restaurativna i endodontska terapija",
      subtitle:
        "Očuvanje prirodnih zuba primjenom suvremenih restaurativnih materijala i preciznih endodontskih postupaka.",
      description:
        "Restaurativna stomatologija obuhvaća obnovu oštećenih zuba primjenom kompozitnih ispuna, inleja, onleja i keramičkih ljuskica izrađenih od premium certificiranih materijala. Endodontska terapija usmjerena je na liječenje pulpnih bolesti i infekcija korjenskih kanala uz korištenje suvremene opreme i tehnika. Svaki zahvat provodi se pod povećalom, uz strogu kontrolu kvalitete i estetske harmonije, s ciljem maksimalnog očuvanja prirodne strukture zuba i postizanja dugoročno stabilnih rezultata.",
      image: image05,
    },
    card_2: {
      title: "Protetska rehabilitacija osmijeha",
      subtitle:
        "Individualno izrađeni protetski radovi za potpunu funkcionalnu i estetsku rehabilitaciju.",
      description:
        "Protetska terapija obuhvaća izradu krunica, mostova, djelomičnih i potpunih proteza te protetskih radova na implantatima. Svi radovi izrađuju se u suradnji s našim integriranim dentalnim laboratorijem, što omogućuje potpunu kontrolu kvalitete, brzu prilagodbu i preciznu komunikaciju između doktora i tehničara. Koristimo isključivo premium materijale uz digitalnu analizu okluzije i estetskih parametara za postizanje prirodnog izgleda i optimalne funkcije.",
      image: image06,
    },
    before_after: {
      title: "Estetska rehabilitacija",
      description: "Prirodan izgled i puna funkcija",
      beforeImage: image05,
      afterImage: image06,
    },
  },
  "integrirani-dentalni-laboratorij": {
    icon: icon05,
    title: "Integrirani dentalni laboratorij",
    subtitle:
      "Vlastiti dentalni laboratorij omogućuje potpunu kontrolu kvalitete, brzu prilagodbu radova i preciznu komunikaciju između doktora i tehničara.",
    card_1: {
      title: "Potpuna kontrola kvalitete",
      subtitle:
        "Vlastiti laboratorij unutar centra za maksimalnu preciznost i kontrolu svakog detalja protetskog rada.",
      description:
        "Posjedovanje vlastitog dentalnog laboratorija unutar Dentivo dentalnog centra ključna je prednost koja osigurava najvišu razinu kvalitete. Direktna komunikacija između doktora i tehničara eliminira nesporazume i omogućuje preciznu prilagodbu svakog rada. Laboratorij je opremljen suvremenom digitalnom opremom za CAD/CAM tehnologiju, što omogućuje izradu visokopreciznih protetskih radova s optimalnom estetikom i funkcijom.",
      image: image07,
    },
    card_2: {
      title: "Individualna prilagodba i najviši standardi",
      subtitle:
        "Svaki rad izrađuje se detaljno i individualno — ne isporučuje se dok ne zadovolji najviše standarde centra.",
      description:
        "Svaki protetski rad izrađuje se detaljno, individualno prilagođen pacijentu i ne isporučuje se dok ne zadovolji najviše standarde centra. Brza prilagodba radova unutar istog objekta skraćuje vrijeme terapije i povećava udobnost pacijenta. Koristimo isključivo premium certificirane materijale, a svaki korak — od digitalne otiske do završne kontrole — provodi se uz strogu kontrolu kvalitete koju postavlja voditelj centra.",
      image: image08,
    },
    before_after: {
      title: "Laboratorijska preciznost",
      description: "Od digitalnog otiska do završnog rada",
      beforeImage: image07,
      afterImage: image08,
    },
  },
};

export type ServiceKey = Exclude<keyof typeof services, "default">;

export type LandingService = {
  icon: StaticImageData;
  title: string;
  subtitle: string;
  href: string;
};

export const landingServices: LandingService[] = [
  {
    icon: icon02,
    title: "Parodontologija i regenerativna kirurgija",
    subtitle:
      "Terapija uznapredovalih parodontnih bolesti, regeneracija mekih i tvrdih tkiva te dugoročna stabilizacija potpornog aparata zuba.",
    href: "/usluge/parodontologija-i-regenerativna-kirurgija",
  },
  {
    icon: icon04,
    title: "Digitalna implantologija",
    subtitle:
      "Precizno planirana implantološka terapija, regeneracija kosti i rješavanje kompleksnih implantoloških situacija.",
    href: "/usluge/digitalna-implantologija",
  },
  {
    icon: icon03,
    title: "Restorativna, endodontska i protetska terapija",
    subtitle:
      "Svi restaurativni i protetski radovi izrađuju se od premium certificiranih materijala uz potpunu kontrolu kvalitete i estetske harmonije.",
    href: "/usluge/restorativna-endodontska-i-protetska-terapija",
  },
  {
    icon: icon05,
    title: "Integrirani dentalni laboratorij",
    subtitle:
      "Vlastiti dentalni laboratorij omogućuje potpunu kontrolu kvalitete, brzu prilagodbu radova i preciznu komunikaciju između doktora i tehničara.",
    href: "/usluge/integrirani-dentalni-laboratorij",
  },
];
